export const SET_DMT_RANGES_LIST = 'SET_DMT_RANGES_LIST';
export const SET_DMT_RANGE_VALUE = 'SET_DMT_RANGE_VALUE';
export const RESET_DMT_RANGES = 'RESET_DMT_RANGES';
export const ADD_DMT_RANGE = 'ADD_DMT_RANGE';
export const SET_DMT_RANGES_MATERIAL_COST_LIST = 'SET_DMT_RANGES_MATERIAL_COST_LIST';
export const SET_WORK_HOUR_VALUES_LIST = 'SET_WORK_HOUR_VALUES_LIST';
